import { lazy, Suspense, useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import CartDrawer from "./CartDrawer";

const ChatWidget = lazy(() => import("./ChatWidget"));

export default function StorefrontLayout() {
  // Widget'ı ilk render'ı geciktirerek yükle (sayfa performansı korunur)
  const [loadChat, setLoadChat] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setLoadChat(true), 1200);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-[#FAF9F5]">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <CartDrawer />
      {loadChat && (
        <Suspense fallback={null}>
          <ChatWidget />
        </Suspense>
      )}
    </div>
  );
}
